import { render, staticRenderFns } from "./bread_crumbs_new.vue?vue&type=template&id=b24bd0f8&"
import script from "./bread_crumbs_new.vue?vue&type=script&lang=js&"
export * from "./bread_crumbs_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports